export const editBannerFile = async ({
  bannerData,
  language,
  aspectBannerRatio,
  bannerUrl,
  editBannerInstructions,
  getToken,
  configData,
}) => {
  if (!bannerUrl) {
    const error = new Error("No banner image available to edit.");
    error.status = 400;
    throw error;
  }

  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  const bodyData = {
    banner_id: `Banner_${bannerData?.chain_name ?? ""}_${language}_${hours}_${minutes}_${seconds}`,
    banner_ratio: aspectBannerRatio,
    banner_director_instructions: `keep the attached image excactly as is. do not add or change any text besides the following instructions: ${editBannerInstructions}`,
    product_title: " ",
    Image_Url: bannerUrl,
  };

  const token = getToken();
  const res = await fetch(`${configData.DEMO_URL}/CreateBanner`, {
    method: "POST",
    headers: {
      "x-access-token": token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(bodyData),
  });

  if (!res.ok) {
    let errorMessage = `Request failed (${res.status})`;
    try {
      const errorBody = await res.json();
      if (errorBody?.message) {
        errorMessage = errorBody.message;
      }
    } catch (_) {}

    const error = new Error(errorMessage);
    error.status = res.status;
    throw error;
  }

  return res.json();
};
